export default __webpack_public_path__ + "static/media/ministerio-02-white.30f83787.svg";